const initialState = {
  loginLoader: false,
  loginFailedMessage: "",
  signupLoader: false,
  signupFailedMessage: "",
  sendingBenInfoLoader: false,
  registerBenActionFailedMessage: "",
  fetchingBeneficiriesLoaders: true,
  fetchingBeneficiriesErroredMessage: "",
  deletingBen: {},
  sendingMarksLoader: false,
  registerMarksActionFailedMessage: "",
  fetchingMarksLoaders: true,
  fetchingMarksErroredMessage: "",
  deletingMarks: {},
  sendingAcYearLoader: false,
  fetchingAcYearLoaders: true,
  AcYearMessage: "",
  deletingAcYear: {},
  term: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    deletingAction: {},
  },
  benInsurance: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
  },
  insurance: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
  },
  assocciation: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
    loadingOne: true,
    loadingOneFailedMsg: "",
  },
  assocciationMembers: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
  },
  benResidence: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
  },
  residence: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
  },
  benSchool: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
  },
  school: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
  },
  benCategory: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
  },
  category: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
  },
  fund: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
    loadingOne: true,
    loadingOneFailedMsg: "",
  },
  fundedBen: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
  },
  benLetter: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
  },
  benCaregiver: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
  },
  benParent: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
  },
  store: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
    loadingOne: true,
    loadingOneFailedMsg: "",
  },
  storedProduct: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
  },
  hhd: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
    creatingAction: {},
  },
  user: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
    loadingOne: true,
    loadingOneFailedMsg: "",
  },
  group: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
    loadingOne: true,
    loadingOneFailedMsg: "",
  },
  benGroup: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
  },
  assoccAsset: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
  },
  assoccReport: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
  },
  benProperty: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
  },
  property: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
  },
  visit: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
    loadingOne: true,
    loadingOneFailedMsg: "",
  },
  yearEvent: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
    loadingOne: true,
    loadingOneFailedMsg: "",
  },
  benVisit: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
  },
  satStudy: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
    loadingOne: true,
    loadingOneFailedMsg: "",
  },
  benSatStudy: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
  },
  meeting: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
    loadingOne: true,
    loadingOneFailedMsg: "",
  },
  benMeeting: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
  },
  healthTest: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
    loadingOne: true,
    loadingOneFailedMsg: "",
  },
  benHealthTest: {
    sendingLoader: false,
    fetchingLoaders: true,
    message: "",
    fetchFailedMessage: "",
    deletingAction: {},
  },
  benProfile: {
    fetchingBenInfo: true,
    fetchingBenInfoErrored: false,
    fetchingBenParent: true,
    fetchingBenParentErrored: false,
    fetchingBenCurrentCaregiver: true,
    fetchingBenCurrentInsurance: true,
    fetchingBenCurrentCategory: true,
    fetchingBenCurrentResidence: true,
    fetchingBenCurrentSchool: true,
    fetchingBenLastRecordedMarks: true,
    fetchingBenLastAttendedSatStudy: true,
    fetchingBenLastAttendedMeeting: true,
    fetchingBenLastAttendedVisit: true,
    fetchingBenLastJoinedAssocciation: true,
    fetchingBenLastFund: true,
    fetchingBenGroups: true,
    fetchingBenProperties: true,

    fetchingBenTotalMeetings: true,
    fetchingBenTotalSatStudies: true,
    fetchingBenTotalVisits: true,
    fetchingBenTotalAssocciations: true,
    fetchingBenTotalFunds: true,

    fetchingBenCurrentCaregiverErrored: false,
    fetchingBenCurrentInsuranceErrored: false,
    fetchingBenCurrentCategoryErrored: false,
    fetchingBenCurrentResidenceErrored: false,
    fetchingBenCurrentSchoolErrored: false,
    fetchingBenLastRecordedMarksErrored: false,
    fetchingBenLastAttendedSatStudyErrored: false,
    fetchingBenLastAttendedMeetingErrored: false,
    fetchingBenLastAttendedVisitErrored: false,
    fetchingBenLastJoinedAssocciationErrored: false,
    fetchingBenLastFundErrored: false,
    fetchingBenGroupsErrored: false,
    fetchingBenPropertiesErrored: false,
    fetchingBenTotalMeetingsErrored: false,
    fetchingBenTotalSatStudiesErrored: false,
    fetchingBenTotalVisitsErrored: false,
    fetchingBenTotalAssocciationsErrored: false,
    fetchingBenTotalFundsErrored: false,
  },
};

const loaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SENDING_LOGIN_INFO":
      return {
        ...state,
        loginLoader: action.loader,
      };
    case "LOGIN_FAILED":
      return {
        ...state,
        loginFailedMessage: action.message,
      };
    case "SENDING_SIGNUP_INFO":
      return {
        ...state,
        signupLoader: action.loader,
      };
    case "SIGNUP_FAILED":
      return {
        ...state,
        signupFailedMessage: action.message,
      };
    case "SENDING_BENEFICIARY_INFO":
      return {
        ...state,
        sendingBenInfoLoader: action.loader,
      };
    case "REGISTER_BENEFICIARY_FAILED":
      return {
        ...state,
        registerBenActionFailedMessage: action.registerBenActionFailedMessage,
      };
    case "DELETING_BENEFICIARY_INFO":
      return {
        ...state,
        deletingBen: action.deletingBen,
      };
    case "GETTING_BENEFICIARY_INFO":
      return {
        ...state,
        fetchingBeneficiriesLoaders: action.fetchingBeneficiriesLoaders,
      };
    case "GET_BENEFICIARY_FAILED":
      return {
        ...state,
        fetchingBeneficiriesErroredMessage:
          action.fetchingBeneficiriesErroredMessage,
      };
    case "SENDING_PERFORMANCE_INFO":
      return {
        ...state,
        sendingMarksLoader: action.loader,
      };
    case "REGISTER_PERFORMANCE_FAILED":
      return {
        ...state,
        registerMarksActionFailedMessage:
          action.registerMarksActionFailedMessage,
      };
    case "DELETING_PERFORMANCE_INFO":
      return {
        ...state,
        deletingMarks: action.deletingMarks,
      };
    case "GETTING_PERFORMANCE_INFO":
      return {
        ...state,
        fetchingMarksLoaders: action.fetchingMarksLoaders,
      };
    case "GET_PERFORMANCE_FAILED":
      return {
        ...state,
        fetchingMarksErroredMessage: action.fetchingMarksErroredMessage,
      };
    case "SENDING_AC_YEAR_INFO":
      return {
        ...state,
        sendingAcYearLoader: action.loader,
      };
    case "DELETING_AC_YEAR_INFO":
      return {
        ...state,
        deletingAcYear: action.deletingAcYear,
      };
    case "GETTING_AC_YEAR_INFO":
      return {
        ...state,
        fetchingAcYearLoaders: action.fetchingAcYearLoaders,
      };
    case "SET_AC_YEAR_MESSAGE":
      return {
        ...state,
        AcYearMessage: action.AcYearMessage,
      };
    case "SENDING_AC_TERM_INFO":
      return {
        ...state,
        term: { sendingLoader: action.loader },
      };
    case "DELETING_AC_TERM_INFO":
      return {
        ...state,
        term: { deletingAction: action.deletingAction },
      };
    case "GETTING_AC_TERM_INFO":
      return {
        ...state,
        term: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_AC_TERM_MESSAGE":
      return {
        ...state,
        term: { message: action.message },
      };
    case "SENDING_BEN_INSURANCE_INFO":
      return {
        ...state,
        benInsurance: { sendingLoader: action.loader },
      };
    case "DELETING_BEN_INSURANCE_INFO":
      return {
        ...state,
        benInsurance: { deletingAction: action.deletingAction },
      };
    case "GETTING_BEN_INSURANCE_INFO":
      return {
        ...state,
        benInsurance: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_BEN_INSURANCE_MESSAGE":
      return {
        ...state,
        benInsurance: { message: action.message },
      };
    case "SET_BEN_INSURANCE_FETCH_FAILED":
      return {
        ...state,
        insurance: { fetchFailedMessage: action.message },
      };
    case "SENDING_INSURANCE_INFO":
      return {
        ...state,
        insurance: { sendingLoader: action.loader },
      };
    case "DELETING_INSURANCE_INFO":
      return {
        ...state,
        insurance: { deletingAction: action.deletingAction },
      };
    case "GETTING_INSURANCE_INFO":
      return {
        ...state,
        insurance: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_INSURANCE_MESSAGE":
      return {
        ...state,
        insurance: { message: action.message },
      };
    case "SET_INSURANCE_FETCH_FAILED":
      return {
        ...state,
        insurance: { fetchFailedMessage: action.message },
      };
    case "SENDING_ASSOCCIATION_INFO":
      return {
        ...state,
        assocciation: { sendingLoader: action.loader },
      };
    case "DELETING_ASSOCCIATION_INFO":
      return {
        ...state,
        assocciation: { deletingAction: action.deletingAction },
      };
    case "GETTING_ASSOCCIATION_INFO":
      return {
        ...state,
        assocciation: { fetchingLoaders: action.fetchingLoaders },
      };
    case "GETTING_ONE_ASSOCCIATION_INFO":
      return {
        ...state,
        assocciation: { loadingOne: action.fetchingLoaders },
      };
    case "SET_ASSOCCIATION_MESSAGE":
      return {
        ...state,
        assocciation: { message: action.message },
      };
    case "SET_ASSOCCIATION_FETCH_FAILED":
      return {
        ...state,
        assocciation: { fetchFailedMessage: action.message },
      };
    case "GET_ASSOCCIATION_FETCH_FAILED":
      return {
        ...state,
        assocciation: { loadingOneFailedMsg: action.message },
      };
    case "SENDING_BEN_ASSOCCIATION_INFO":
      return {
        ...state,
        assocciationMembers: { sendingLoader: action.loader },
      };
    case "DELETING_BEN_ASSOCCIATION_INFO":
      return {
        ...state,
        assocciationMembers: { deletingAction: action.deletingAction },
      };
    case "GETTING_BEN_ASSOCCIATION_INFO":
      return {
        ...state,
        assocciationMembers: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_BEN_ASSOCCIATION_MESSAGE":
      return {
        ...state,
        assocciationMembers: { message: action.message },
      };
    case "SET_BEN_ASSOCCIATION_FETCH_FAILED":
      return {
        ...state,
        assocciationMembers: { fetchFailedMessage: action.message },
      };

    case "SENDING_BEN_RESIDENCE_INFO":
      return {
        ...state,
        benResidence: { sendingLoader: action.loader },
      };
    case "DELETING_BEN_RESIDENCE_INFO":
      return {
        ...state,
        benResidence: { deletingAction: action.deletingAction },
      };
    case "GETTING_BEN_RESIDENCE_INFO":
      return {
        ...state,
        benResidence: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_BEN_RESIDENCE_MESSAGE":
      return {
        ...state,
        benResidence: { message: action.message },
      };
    case "SET_BEN_RESIDENCE_FETCH_FAILED":
      return {
        ...state,
        benResidence: { fetchFailedMessage: action.message },
      };

    case "SENDING_RESIDENCE_INFO":
      return {
        ...state,
        residence: { sendingLoader: action.loader },
      };
    case "DELETING_RESIDENCE_INFO":
      return {
        ...state,
        residence: { deletingAction: action.deletingAction },
      };
    case "GETTING_RESIDENCE_INFO":
      return {
        ...state,
        residence: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_RESIDENCE_MESSAGE":
      return {
        ...state,
        residence: { message: action.message },
      };
    case "SET_RESIDENCE_FETCH_FAILED":
      return {
        ...state,
        residence: { fetchFailedMessage: action.message },
      };

    case "SENDING_BEN_SCHOOL_INFO":
      return {
        ...state,
        benSchool: { sendingLoader: action.loader },
      };
    case "DELETING_BEN_SCHOOL_INFO":
      return {
        ...state,
        benSchool: { deletingAction: action.deletingAction },
      };
    case "GETTING_BEN_SCHOOL_INFO":
      return {
        ...state,
        benSchool: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_BEN_SCHOOL_MESSAGE":
      return {
        ...state,
        benSchool: { message: action.message },
      };
    case "SET_BEN_SCHOOL_FETCH_FAILED":
      return {
        ...state,
        benSchool: { fetchFailedMessage: action.message },
      };

    case "SENDING_SCHOOL_INFO":
      return {
        ...state,
        school: { sendingLoader: action.loader },
      };
    case "DELETING_SCHOOL_INFO":
      return {
        ...state,
        school: { deletingAction: action.deletingAction },
      };
    case "GETTING_SCHOOL_INFO":
      return {
        ...state,
        school: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_SCHOOL_MESSAGE":
      return {
        ...state,
        school: { message: action.message },
      };
    case "SET_SCHOOL_FETCH_FAILED":
      return {
        ...state,
        school: { fetchFailedMessage: action.message },
      };
    case "SENDING_BEN_CATEGORY_INFO":
      return {
        ...state,
        benCategory: { sendingLoader: action.loader },
      };
    case "DELETING_BEN_CATEGORY_INFO":
      return {
        ...state,
        benCategory: { deletingAction: action.deletingAction },
      };
    case "GETTING_BEN_CATEGORY_INFO":
      return {
        ...state,
        benCategory: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_BEN_CATEGORY_MESSAGE":
      return {
        ...state,
        benCategory: { message: action.message },
      };
    case "SET_BEN_CATEGORY_FETCH_FAILED":
      return {
        ...state,
        benCategory: { fetchFailedMessage: action.message },
      };

    case "SENDING_CATEGORY_INFO":
      return {
        ...state,
        category: { sendingLoader: action.loader },
      };
    case "DELETING_CATEGORY_INFO":
      return {
        ...state,
        category: { deletingAction: action.deletingAction },
      };
    case "GETTING_CATEGORY_INFO":
      return {
        ...state,
        category: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_CATEGORY_MESSAGE":
      return {
        ...state,
        category: { message: action.message },
      };
    case "SET_CATEGORY_FETCH_FAILED":
      return {
        ...state,
        category: { fetchFailedMessage: action.message },
      };
    case "SENDING_FUND_INFO":
      return {
        ...state,
        fund: { sendingLoader: action.loader },
      };
    case "DELETING_FUND_INFO":
      return {
        ...state,
        fund: { deletingAction: action.deletingAction },
      };
    case "GETTING_FUND_INFO":
      return {
        ...state,
        fund: { fetchingLoaders: action.fetchingLoaders },
      };
    case "GETTING_ONE_FUND_INFO":
      return {
        ...state,
        fund: { loadingOne: action.fetchingLoaders },
      };
    case "SET_FUND_MESSAGE":
      return {
        ...state,
        fund: { message: action.message },
      };
    case "SET_FUND_FETCH_FAILED":
      return {
        ...state,
        fund: { fetchFailedMessage: action.message },
      };
    case "GET_FUND_FETCH_FAILED":
      return {
        ...state,
        fund: { loadingOneFailedMsg: action.message },
      };
    case "SENDING_BEN_FUND_INFO":
      return {
        ...state,
        fundedBen: { sendingLoader: action.loader },
      };
    case "DELETING_BEN_FUND_INFO":
      return {
        ...state,
        fundedBen: { deletingAction: action.deletingAction },
      };
    case "GETTING_BEN_FUND_INFO":
      return {
        ...state,
        fundedBen: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_BEN_FUND_MESSAGE":
      return {
        ...state,
        fundedBen: { message: action.message },
      };
    case "SET_BEN_FUND_FETCH_FAILED":
      return {
        ...state,
        fundedBen: { fetchFailedMessage: action.message },
      };

    case "SENDING_BEN_LETTER_INFO":
      return {
        ...state,
        benLetter: { sendingLoader: action.loader },
      };
    case "DELETING_BEN_LETTER_INFO":
      return {
        ...state,
        benLetter: { deletingAction: action.deletingAction },
      };
    case "GETTING_BEN_LETTER_INFO":
      return {
        ...state,
        benLetter: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_BEN_LETTER_MESSAGE":
      return {
        ...state,
        benLetter: { message: action.message },
      };
    case "SET_BEN_LETTER_FETCH_FAILED":
      return {
        ...state,
        benLetter: { fetchFailedMessage: action.message },
      };
    case "SENDING_STORE_INFO":
      return {
        ...state,
        store: { sendingLoader: action.loader },
      };
    case "DELETING_STORE_INFO":
      return {
        ...state,
        store: { deletingAction: action.deletingAction },
      };
    case "GETTING_STORE_INFO":
      return {
        ...state,
        store: { fetchingLoaders: action.fetchingLoaders },
      };
    case "GETTING_ONE_STORE_INFO":
      return {
        ...state,
        store: { loadingOne: action.fetchingLoaders },
      };
    case "SET_STORE_MESSAGE":
      return {
        ...state,
        store: { message: action.message },
      };
    case "SET_STORE_FETCH_FAILED":
      return {
        ...state,
        store: { fetchFailedMessage: action.message },
      };
    case "GET_STORE_FETCH_FAILED":
      return {
        ...state,
        store: { loadingOneFailedMsg: action.message },
      };
    case "SENDING_STORED_PRODUCT_INFO":
      return {
        ...state,
        storedProduct: { sendingLoader: action.loader },
      };
    case "DELETING_STORED_PRODUCT_INFO":
      return {
        ...state,
        storedProduct: { deletingAction: action.deletingAction },
      };
    case "GETTING_STORED_PRODUCT_INFO":
      return {
        ...state,
        storedProduct: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_STORED_PRODUCT_MESSAGE":
      return {
        ...state,
        storedProduct: { message: action.message },
      };
    case "SET_STORED_PRODUCT_FETCH_FAILED":
      return {
        ...state,
        storedProduct: { fetchFailedMessage: action.message },
      };
    case "SENDING_BEN_PARENT_INFO":
      return {
        ...state,
        benParent: { sendingLoader: action.loader },
      };
    case "DELETING_BEN_PARENT_INFO":
      return {
        ...state,
        benParent: { deletingAction: action.deletingAction },
      };
    case "GETTING_BEN_PARENT_INFO":
      return {
        ...state,
        benParent: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_BEN_PARENT_MESSAGE":
      return {
        ...state,
        benParent: { message: action.message },
      };
    case "SET_BEN_PARENT_FETCH_FAILED":
      return {
        ...state,
        benParent: { fetchFailedMessage: action.message },
      };
    case "SENDING_BEN_CAREGIVER_INFO":
      return {
        ...state,
        benCaregiver: { sendingLoader: action.loader },
      };
    case "DELETING_BEN_CAREGIVER_INFO":
      return {
        ...state,
        benCaregiver: { deletingAction: action.deletingAction },
      };
    case "GETTING_BEN_CAREGIVER_INFO":
      return {
        ...state,
        benCaregiver: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_BEN_CAREGIVER_MESSAGE":
      return {
        ...state,
        benCaregiver: { message: action.message },
      };
    case "SET_BEN_CAREGIVER_FETCH_FAILED":
      return {
        ...state,
        benCaregiver: { fetchFailedMessage: action.message },
      };
    case "SENDING_BEN_HHD_INFO":
      return {
        ...state,
        hhd: { sendingLoader: action.loader },
      };
    case "DELETING_BEN_HHD_INFO":
      return {
        ...state,
        hhd: { deletingAction: action.deletingAction },
      };
    case "CREATING_BEN_HHD_INFO":
      return {
        ...state,
        hhd: { creatingAction: action.creatingAction },
      };
    case "GETTING_BEN_HHD_INFO":
      return {
        ...state,
        hhd: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_BEN_HHD_MESSAGE":
      return {
        ...state,
        hhd: { message: action.message },
      };
    case "SET_BEN_HHD_FETCH_FAILED":
      return {
        ...state,
        hhd: { fetchFailedMessage: action.message },
      };
    case "SENDING_USER_INFO":
      return {
        ...state,
        user: { sendingLoader: action.loader },
      };
    case "DELETING_USER_INFO":
      return {
        ...state,
        user: { deletingAction: action.deletingAction },
      };
    case "GETTING_USER_INFO":
      return {
        ...state,
        user: { fetchingLoaders: action.fetchingLoaders },
      };
    case "GETTING_ONE_USER_INFO":
      return {
        ...state,
        user: { loadingOne: action.fetchingLoaders },
      };
    case "SET_USER_MESSAGE":
      return {
        ...state,
        user: { message: action.message },
      };
    case "SET_USER_FETCH_FAILED":
      return {
        ...state,
        user: { fetchFailedMessage: action.message },
      };
    case "GET_USER_FETCH_FAILED":
      return {
        ...state,
        user: { loadingOneFailedMsg: action.message },
      };
    case "SENDING_GROUP_INFO":
      return {
        ...state,
        group: { sendingLoader: action.loader },
      };
    case "DELETING_GROUP_INFO":
      return {
        ...state,
        group: { deletingAction: action.deletingAction },
      };
    case "GETTING_GROUP_INFO":
      return {
        ...state,
        group: { fetchingLoaders: action.fetchingLoaders },
      };
    case "GETTING_ONE_GROUP_INFO":
      return {
        ...state,
        group: { loadingOne: action.fetchingLoaders },
      };
    case "SET_GROUP_MESSAGE":
      return {
        ...state,
        group: { message: action.message },
      };
    case "SET_GROUP_FETCH_FAILED":
      return {
        ...state,
        group: { fetchFailedMessage: action.message },
      };
    case "GET_GROUP_FETCH_FAILED":
      return {
        ...state,
        group: { loadingOneFailedMsg: action.message },
      };
    case "SENDING_BEN_GROUP_INFO":
      return {
        ...state,
        benGroup: { sendingLoader: action.loader },
      };
    case "DELETING_BEN_GROUP_INFO":
      return {
        ...state,
        benGroup: { deletingAction: action.deletingAction },
      };
    case "GETTING_BEN_GROUP_INFO":
      return {
        ...state,
        benGroup: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_BEN_GROUP_MESSAGE":
      return {
        ...state,
        benGroup: { message: action.message },
      };
    case "SET_BEN_GROUP_FETCH_FAILED":
      return {
        ...state,
        benGroup: { fetchFailedMessage: action.message },
      };
    case "SENDING_BEN_PROPERTY_INFO":
      return {
        ...state,
        benProperty: { sendingLoader: action.loader },
      };
    case "DELETING_BEN_PROPERTY_INFO":
      return {
        ...state,
        benProperty: { deletingAction: action.deletingAction },
      };
    case "GETTING_BEN_PROPERTY_INFO":
      return {
        ...state,
        benProperty: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_BEN_PROPERTY_MESSAGE":
      return {
        ...state,
        benProperty: { message: action.message },
      };
    case "SET_BEN_PROPERTY_FETCH_FAILED":
      return {
        ...state,
        benProperty: { fetchFailedMessage: action.message },
      };

    case "SENDING_PROPERTY_INFO":
      return {
        ...state,
        property: { sendingLoader: action.loader },
      };
    case "DELETING_PROPERTY_INFO":
      return {
        ...state,
        property: { deletingAction: action.deletingAction },
      };
    case "GETTING_PROPERTY_INFO":
      return {
        ...state,
        property: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_PROPERTY_MESSAGE":
      return {
        ...state,
        property: { message: action.message },
      };
    case "SET_PROPERTY_FETCH_FAILED":
      return {
        ...state,
        property: { fetchFailedMessage: action.message },
      };
    case "SENDING_HEALTH_TEST_INFO":
      return {
        ...state,
        healthTest: { sendingLoader: action.loader },
      };
    case "DELETING_HEALTH_TEST_INFO":
      return {
        ...state,
        healthTest: { deletingAction: action.deletingAction },
      };
    case "GETTING_HEALTH_TEST_INFO":
      return {
        ...state,
        healthTest: { fetchingLoaders: action.fetchingLoaders },
      };
    case "GETTING_ONE_HEALTH_TEST_INFO":
      return {
        ...state,
        healthTest: { loadingOne: action.fetchingLoaders },
      };
    case "SET_HEALTH_TEST_MESSAGE":
      return {
        ...state,
        healthTest: { message: action.message },
      };
    case "SET_HEALTH_TEST_FETCH_FAILED":
      return {
        ...state,
        healthTest: { fetchFailedMessage: action.message },
      };
    case "GET_HEALTH_TEST_FETCH_FAILED":
      return {
        ...state,
        healthTest: { loadingOneFailedMsg: action.message },
      };
    case "SENDING_BEN_HEALTH_TEST_INFO":
      return {
        ...state,
        benHealthTest: { sendingLoader: action.loader },
      };
    case "DELETING_BEN_HEALTH_TEST_INFO":
      return {
        ...state,
        benHealthTest: { deletingAction: action.deletingAction },
      };
    case "GETTING_BEN_HEALTH_TEST_INFO":
      return {
        ...state,
        benHealthTest: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_BEN_HEALTH_TEST_MESSAGE":
      return {
        ...state,
        benHealthTest: { message: action.message },
      };
    case "SET_BEN_HEALTH_TEST_FETCH_FAILED":
      return {
        ...state,
        benHealthTest: { fetchFailedMessage: action.message },
      };
    case "SENDING_VISIT_INFO":
      return {
        ...state,
        visit: { sendingLoader: action.loader },
      };
    case "DELETING_VISIT_INFO":
      return {
        ...state,
        visit: { deletingAction: action.deletingAction },
      };
    case "GETTING_VISIT_INFO":
      return {
        ...state,
        visit: { fetchingLoaders: action.fetchingLoaders },
      };
    case "GETTING_ONE_VISIT_INFO":
      return {
        ...state,
        visit: { loadingOne: action.fetchingLoaders },
      };
    case "SET_VISIT_MESSAGE":
      return {
        ...state,
        visit: { message: action.message },
      };
    case "SET_VISIT_FETCH_FAILED":
      return {
        ...state,
        visit: { fetchFailedMessage: action.message },
      };
    case "GET_VISIT_FETCH_FAILED":
      return {
        ...state,
        visit: { loadingOneFailedMsg: action.message },
      };
    case "SENDING_BEN_VISIT_INFO":
      return {
        ...state,
        benVisit: { sendingLoader: action.loader },
      };
    case "DELETING_BEN_VISIT_INFO":
      return {
        ...state,
        benVisit: { deletingAction: action.deletingAction },
      };
    case "GETTING_BEN_VISIT_INFO":
      return {
        ...state,
        benVisit: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_BEN_VISIT_MESSAGE":
      return {
        ...state,
        benVisit: { message: action.message },
      };
    case "SET_BEN_VISIT_FETCH_FAILED":
      return {
        ...state,
        benVisit: { fetchFailedMessage: action.message },
      };
    case "SENDING_MEETING_INFO":
      return {
        ...state,
        meeting: { sendingLoader: action.loader },
      };
    case "DELETING_MEETING_INFO":
      return {
        ...state,
        meeting: { deletingAction: action.deletingAction },
      };
    case "GETTING_MEETING_INFO":
      return {
        ...state,
        meeting: { fetchingLoaders: action.fetchingLoaders },
      };
    case "GETTING_ONE_MEETING_INFO":
      return {
        ...state,
        meeting: { loadingOne: action.fetchingLoaders },
      };
    case "SET_MEETING_MESSAGE":
      return {
        ...state,
        meeting: { message: action.message },
      };
    case "SET_MEETING_FETCH_FAILED":
      return {
        ...state,
        meeting: { fetchFailedMessage: action.message },
      };
    case "GET_MEETING_FETCH_FAILED":
      return {
        ...state,
        meeting: { loadingOneFailedMsg: action.message },
      };
    case "SENDING_BEN_MEETING_INFO":
      return {
        ...state,
        benMeeting: { sendingLoader: action.loader },
      };
    case "DELETING_BEN_MEETING_INFO":
      return {
        ...state,
        benMeeting: { deletingAction: action.deletingAction },
      };
    case "GETTING_BEN_MEETING_INFO":
      return {
        ...state,
        benMeeting: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_BEN_MEETING_MESSAGE":
      return {
        ...state,
        benMeeting: { message: action.message },
      };
    case "SET_BEN_MEETING_FETCH_FAILED":
      return {
        ...state,
        benMeeting: { fetchFailedMessage: action.message },
      };
    case "SENDING_SAT_STUDY_INFO":
      return {
        ...state,
        satStudy: { sendingLoader: action.loader },
      };
    case "DELETING_SAT_STUDY_INFO":
      return {
        ...state,
        satStudy: { deletingAction: action.deletingAction },
      };
    case "GETTING_SAT_STUDY_INFO":
      return {
        ...state,
        satStudy: { fetchingLoaders: action.fetchingLoaders },
      };
    case "GETTING_ONE_SAT_STUDY_INFO":
      return {
        ...state,
        satStudy: { loadingOne: action.fetchingLoaders },
      };
    case "SET_SAT_STUDY_MESSAGE":
      return {
        ...state,
        satStudy: { message: action.message },
      };
    case "SET_SAT_STUDY_FETCH_FAILED":
      return {
        ...state,
        satStudy: { fetchFailedMessage: action.message },
      };
    case "GET_SAT_STUDY_FETCH_FAILED":
      return {
        ...state,
        satStudy: { loadingOneFailedMsg: action.message },
      };
    case "SENDING_BEN_SAT_STUDY_INFO":
      return {
        ...state,
        benSatStudy: { sendingLoader: action.loader },
      };
    case "DELETING_BEN_SAT_STUDY_INFO":
      return {
        ...state,
        benSatStudy: { deletingAction: action.deletingAction },
      };
    case "GETTING_BEN_SAT_STUDY_INFO":
      return {
        ...state,
        benSatStudy: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_BEN_SAT_STUDY_MESSAGE":
      return {
        ...state,
        benSatStudy: { message: action.message },
      };
    case "SET_BEN_SAT_STUDY_FETCH_FAILED":
      return {
        ...state,
        benSatStudy: { fetchFailedMessage: action.message },
      };
    case "SENDING_YEAR_EVENT_INFO":
      return {
        ...state,
        yearEvent: { sendingLoader: action.loader },
      };
    case "DELETING_YEAR_EVENT_INFO":
      return {
        ...state,
        yearEvent: { deletingAction: action.deletingAction },
      };
    case "GETTING_YEAR_EVENT_INFO":
      return {
        ...state,
        yearEvent: { fetchingLoaders: action.fetchingLoaders },
      };
    case "GETTING_ONE_YEAR_EVENT_INFO":
      return {
        ...state,
        yearEvent: { loadingOne: action.fetchingLoaders },
      };
    case "SET_YEAR_EVENT_MESSAGE":
      return {
        ...state,
        yearEvent: { message: action.message },
      };
    case "SET_YEAR_EVENT_FETCH_FAILED":
      return {
        ...state,
        yearEvent: { fetchFailedMessage: action.message },
      };
    case "GET_YEAR_EVENT_FETCH_FAILED":
      return {
        ...state,
        yearEvent: { loadingOneFailedMsg: action.message },
      };
    case "GETTING_BEN_PROFILE_INFO":
      return {
        ...state,
        benProfile: { fetchingBenInfo: action.fetchingInfo },
      };
    case "GETTING_BEN_PROFILE_INFO_ERRORED":
      return {
        ...state,
        benProfile: { fetchingBenInfoErrored: action.fetchingInfoErrored },
      };
    case "GETTING_BEN_PROFILE_PARENT_INFO":
      return {
        ...state,
        benProfile: { fetchingBenParent: action.fetchingInfo },
      };
    case "GETTING_BEN_PROFILE_PARENT_ERRORED":
      return {
        ...state,
        benProfile: { fetchingBenParentErrored: action.fetchingInfoErrored },
      };
    case "GETTING_BEN_PROFILE_CAREGIVER_INFO":
      return {
        ...state,
        benProfile: { fetchingBenCurrentCaregiver: action.fetchingInfo },
      };
    case "GETTING_BEN_PROFILE_CAREGIVER_ERRORED":
      return {
        ...state,
        benProfile: {
          fetchingBenCurrentCaregiverErrored: action.fetchingInfoErrored,
        },
      };
    case "GETTING_BEN_PROFILE_INSURANCE_INFO":
      return {
        ...state,
        benProfile: { fetchingBenCurrentInsurance: action.fetchingInfo },
      };
    case "GETTING_BEN_PROFILE_INSURANCE_ERRORED":
      return {
        ...state,
        benProfile: {
          fetchingBenCurrentInsuranceErrored: action.fetchingInfoErrored,
        },
      };
    case "GETTING_BEN_PROFILE_CATEGORY_INFO":
      return {
        ...state,
        benProfile: { fetchingBenCurrentCategory: action.fetchingInfo },
      };
    case "GETTING_BEN_PROFILE_CATEGORY_ERRORED":
      return {
        ...state,
        benProfile: {
          fetchingBenCurrentCategoryErrored: action.fetchingInfoErrored,
        },
      };
    case "GETTING_BEN_PROFILE_RESIDENCE_INFO":
      return {
        ...state,
        benProfile: { fetchingBenCurrentResidence: action.fetchingInfo },
      };
    case "GETTING_BEN_PROFILE_RESIDENCE_ERRORED":
      return {
        ...state,
        benProfile: {
          fetchingBenCurrentResidenceErrored: action.fetchingInfoErrored,
        },
      };
    case "GETTING_BEN_PROFILE_SCHOOL_INFO":
      return {
        ...state,
        benProfile: { fetchingBenCurrentSchool: action.fetchingInfo },
      };
    case "GETTING_BEN_PROFILE_SCHOOL_ERRORED":
      return {
        ...state,
        benProfile: {
          fetchingBenCurrentSchoolErrored: action.fetchingInfoErrored,
        },
      };
    case "GETTING_BEN_PROFILE_MARKS_INFO":
      return {
        ...state,
        benProfile: { fetchingBenLastRecordedMarks: action.fetchingInfo },
      };
    case "GETTING_BEN_PROFILE_MARKS_ERRORED":
      return {
        ...state,
        benProfile: {
          fetchingBenLastRecordedMarksErrored: action.fetchingInfoErrored,
        },
      };
    case "GETTING_BEN_PROFILE_SAT_STUDY_INFO":
      return {
        ...state,
        benProfile: { fetchingBenLastAttendedSatStudy: action.fetchingInfo },
      };
    case "GETTING_BEN_PROFILE_SAT_STUDY_ERRORED":
      return {
        ...state,
        benProfile: {
          fetchingBenLastAttendedSatStudyErrored: action.fetchingInfoErrored,
        },
      };
    case "GETTING_BEN_PROFILE_MEETING_INFO":
      return {
        ...state,
        benProfile: { fetchingBenLastAttendedMeeting: action.fetchingInfo },
      };
    case "GETTING_BEN_PROFILE_MEETING_ERRORED":
      return {
        ...state,
        benProfile: {
          fetchingBenLastAttendedMeetingErrored: action.fetchingInfoErrored,
        },
      };
    case "GETTING_BEN_PROFILE_VISIT_INFO":
      return {
        ...state,
        benProfile: { fetchingBenLastAttendedVisit: action.fetchingInfo },
      };
    case "GETTING_BEN_PROFILE_VISIT_ERRORED":
      return {
        ...state,
        benProfile: {
          fetchingBenLastAttendedVisitErrored: action.fetchingInfoErrored,
        },
      };
    case "GETTING_BEN_PROFILE_ASSOCCIATION_INFO":
      return {
        ...state,
        benProfile: { fetchingBenLastJoinedAssocciation: action.fetchingInfo },
      };
    case "GETTING_BEN_PROFILE_ASSOCCIATION_ERRORED":
      return {
        ...state,
        benProfile: {
          fetchingBenLastJoinedAssocciationErrored: action.fetchingInfoErrored,
        },
      };
    case "GETTING_BEN_PROFILE_FUND_INFO":
      return {
        ...state,
        benProfile: { fetchingBenLastFund: action.fetchingInfo },
      };
    case "GETTING_BEN_PROFILE_FUND_ERRORED":
      return {
        ...state,
        benProfile: {
          fetchingBenLastFundErrored: action.fetchingInfoErrored,
        },
      };
    case "GETTING_BEN_PROFILE_TOTAL_MEETING_INFO":
      return {
        ...state,
        benProfile: { fetchingBenTotalMeetings: action.fetchingInfo },
      };
    case "GETTING_BEN_PROFILE_TOTAL_MEETING_ERRORED":
      return {
        ...state,
        benProfile: {
          fetchingBenTotalMeetingsErrored: action.fetchingInfoErrored,
        },
      };
    case "GETTING_BEN_PROFILE_TOTAL_SAT_STUDY_INFO":
      return {
        ...state,
        benProfile: { fetchingBenTotalSatStudies: action.fetchingInfo },
      };
    case "GETTING_BEN_PROFILE_TOTAL_SAT_STUDY_ERRORED":
      return {
        ...state,
        benProfile: {
          fetchingBenTotalSatStudiesErrored: action.fetchingInfoErrored,
        },
      };
    case "GETTING_BEN_PROFILE_TOTAL_VISIT_INFO":
      return {
        ...state,
        benProfile: { fetchingBenTotalVisits: action.fetchingInfo },
      };
    case "GETTING_BEN_PROFILE_TOTAL_VISIT_ERRORED":
      return {
        ...state,
        benProfile: {
          fetchingBenTotalVisitsErrored: action.fetchingInfoErrored,
        },
      };
    case "GETTING_BEN_PROFILE_TOTAL_ASSOCCIATION_INFO":
      return {
        ...state,
        benProfile: { fetchingBenTotalAssocciations: action.fetchingInfo },
      };
    case "GETTING_BEN_PROFILE_TOTAL_ASSOCCIATION_ERRORED":
      return {
        ...state,
        benProfile: {
          fetchingBenTotalAssocciationsErrored: action.fetchingInfoErrored,
        },
      };
    case "GETTING_BEN_PROFILE_TOTAL_FUND_INFO":
      return {
        ...state,
        benProfile: { fetchingBenTotalFunds: action.fetchingInfo },
      };
    case "GETTING_BEN_PROFILE_TOTAL_FUND_ERRORED":
      return {
        ...state,
        benProfile: {
          fetchingBenTotalFundsErrored: action.fetchingInfoErrored,
        },
      };
    case "GETTING_BEN_PROFILE_TOTAL_GROUP_INFO":
      return {
        ...state,
        benProfile: { fetchingBenGroups: action.fetchingInfo },
      };
    case "GETTING_BEN_PROFILE_TOTAL_GROUP_ERRORED":
      return {
        ...state,
        benProfile: {
          fetchingBenGroupsErrored: action.fetchingInfoErrored,
        },
      };
    case "GETTING_BEN_PROFILE_TOTAL_PROPERTIES_INFO":
      return {
        ...state,
        benProfile: { fetchingBenGroups: action.fetchingInfo },
      };
    case "GETTING_BEN_PROFILE_TOTAL_PROPERTIES_ERRORED":
      return {
        ...state,
        benProfile: {
          fetchingBenPropertiesErrored: action.fetchingInfoErrored,
        },
      };
    case "SENDING_ASSOCC_ASSET_INFO":
      return {
        ...state,
        assoccAsset: { sendingLoader: action.loader },
      };
    case "DELETING_ASSOCC_ASSET_INFO":
      return {
        ...state,
        assoccAsset: { deletingAction: action.deletingAction },
      };
    case "GETTING_ASSOCC_ASSET_INFO":
      return {
        ...state,
        assoccAsset: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_ASSOCC_ASSET_MESSAGE":
      return {
        ...state,
        assoccAsset: { message: action.message },
      };
    case "SET_ASSOCC_ASSET_FETCH_FAILED":
      return {
        ...state,
        assoccAsset: { fetchFailedMessage: action.message },
      };
    case "SENDING_ASSOCC_REPORT_INFO":
      return {
        ...state,
        assoccReport: { sendingLoader: action.loader },
      };
    case "DELETING_ASSOCC_REPORT_INFO":
      return {
        ...state,
        assoccReport: { deletingAction: action.deletingAction },
      };
    case "GETTING_ASSOCC_REPORT_INFO":
      return {
        ...state,
        assoccReport: { fetchingLoaders: action.fetchingLoaders },
      };
    case "SET_ASSOCC_REPORT_MESSAGE":
      return {
        ...state,
        assoccReport: { message: action.message },
      };
    case "SET_ASSOCC_REPORT_FETCH_FAILED":
      return {
        ...state,
        assoccReport: { fetchFailedMessage: action.message },
      };
    default:
      return state;
  }
};
export default loaderReducer;
